/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { StudentProfile } from '../../models/student-profile';

export interface UpdateStudentProfile$Params {
  id: string;
      body?: StudentProfile
}

export function updateStudentProfile(http: HttpClient, rootUrl: string, params: UpdateStudentProfile$Params, context?: HttpContext): Observable<StrictHttpResponse<StudentProfile>> {
  const rb = new RequestBuilder(rootUrl, updateStudentProfile.PATH, 'put');
  if (params) {
    rb.path('id', params.id, {});
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<StudentProfile>;
    })
  );
}

updateStudentProfile.PATH = '/studentprofile/{id}';
